import { render, staticRenderFns } from "./TMenuNavItem.vue?vue&type=template&id=54ad5b48&scoped=true&"
import script from "./TMenuNavItem.vue?vue&type=script&lang=js&"
export * from "./TMenuNavItem.vue?vue&type=script&lang=js&"
import style0 from "./TMenuNavItem.vue?vue&type=style&index=0&id=54ad5b48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ad5b48",
  null
  
)

export default component.exports